import { useLocalSearchParams } from 'expo-router';
import { EventPageView } from '../../src/components/event/EventPageView';
import { usePublicPlanEvent } from '../../src/hooks/usePublicPlanEvent';

/**
 * /event/<id>: the public page for one plan event (see EventPageView). It works
 * signed out, so the root layout lists it with the other public routes.
 */
export default function EventScreen() {
  const { eventId } = useLocalSearchParams<{ eventId: string }>();
  const { state, noteGoingCount } = usePublicPlanEvent(eventId);
  return <EventPageView state={state} noteGoingCount={noteGoingCount} />;
}
